window.theme = window.theme || {};

theme.getVariantIdFromUrlOrDefault = function ($select) {
  var variantId = null;
  var href = window.location.href;

  if (href.indexOf("?variant=") !== -1) {
    variantId = href.split("?variant=").pop().split("&")[0].split("#")[0];
  }

  if (!$select || !$select.length) {
    return variantId;
  }

  if (variantId && $select.find('option[value="' + variantId + '"]').length) {
    return variantId;
  }

  var $firstOption = $select.find("option").first();
  return $firstOption.length ? $firstOption.val() : null;
};

// theme.refreshPdpMobileMediaSlider = function (variantHandle, showAllVariants) {
//   if ($(window).width() >= 750) return;

//   var $mediaSlider = $(".product-single .product-single__media-group-inner");

//   if (!$mediaSlider.length || !$mediaSlider.hasClass("slick-initialized")) return;

//   $mediaSlider.slick("slickUnfilter");

//   var filterSelector = ".product-single__media-wrapper";

//   if (!showAllVariants && variantHandle) {
//     filterSelector =
//       ".product-single__media-wrapper." +
//       variantHandle +
//       ", .product-single__media-wrapper.all" +
//       ", .product-single__media-wrapper[data-product-single-media-wrapper]";
//   }

//   $mediaSlider.slick("slickFilter", filterSelector);
//   $mediaSlider.slick("slickGoTo", 0, true);
//   $mediaSlider.slick("setPosition");
// };

$(document).ready(function () {
  // Mobile Nav js
  const mobile_nav = {
    expand_nav: function () {
      $(".menu-nav__with-dropdown .toggle-icon").on("click", function () {
        $(this).closest(".menu-nav__with-dropdown").toggleClass("active");
        const menu_to_toggle = $(this)
          .closest(".menu-nav__with-dropdown")
          .data("title");
        $(`[data-parent="${menu_to_toggle}"]`).slideToggle();
      });
    },
    open_nav: function () {
      $(".mobile-nav--open").on("click", function () {
        $("body").addClass("show-menu-drawer");
      });
     $(".mobile-nav__close, .popup-overlay").on("click", function () {
        $("body").removeClass("show-menu-drawer");
        $(".mobile-nav-wrapper").removeClass("js-menu--is-open").css('transform', 'translate(-100%)');
        $(".site-header__menu").removeClass("mobile-nav--close").addClass("mobile-nav--open").attr('aria-expanded', 'false');
      });
    },
  };
  mobile_nav.expand_nav();
  mobile_nav.open_nav();

  // Collections Navigation hover script
  $(".site-nav .collections div[data-nav-content]:first-child").show();
  $(".site-nav .collections .site-nav__child-link").hover(function () {
    let collectionsNavLink = $(this).data("nav-link");
    $('[data-nav-content="' + collectionsNavLink + '"]')
      .show()
      .siblings()
      .hide();
  });

  // Image with contnet js
  $(".image-content-wrapper").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    adaptiveHeight: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  });
});

//******Two Image with contnet js *///*

$(document).ready(function () {
  $(".two-image-content-parent").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    adaptiveHeight: true,
    arrows: false,
  });
});

//******four column content js *///*
if (window.screen.width <= 768) {
  $(document).ready(function () {
    $(".four-column-img").slick({
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: false,
    });
  });
}

//******bespoke image content js *///*
if (window.screen.width <= 768) {
  $(document).ready(function () {
    $(".bespoke-mob-image-content").slick({
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: false,
    });
  });
}
//******collection page main banner js *///*
// $(document).ready(function () {
//   $(".collection-video-wrapper").slick({
//     dots: true,
//     infinite: true,
//     autoplay: false,
//     autoplaySpeed: false,
//     slidesToShow: 1,
//     adaptiveHeight: true,
//     arrows: true,
//   });
// });

//******Store locator js *///*

// $(document).ready(function () {
//   $(".store-locator-banner-wrapper").slick({
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     slidesToShow: 1,
//     adaptiveHeight: true,
//     arrows: false,
//   });
// });
// if (window.screen.width <= 768) {
//   $(document).ready(function () {
//     $(".store-locator-banner-wrapper-mob").slick({
//       dots: true,
//       infinite: true,
//       autoplay: true,
//       autoplaySpeed: 2000,
//       slidesToShow: 1,
//       adaptiveHeight: true,
//       arrows: false,
//     });
//   });
// }

// PLP Script
// Custom filter dropdown menu
$(document).on("click", ".desktop-filter .filter-option-heading", function () {
  $(this)
    .parents(".mm-filter-nav")
    .siblings()
    .find(".filter-content")
    .slideUp(300);
  $(this).next(".filter-content").slideToggle(300);
});
$("body").click(function (e) {
  if ($(window).width() > 767) {
    if ($(e.target).closest(".desktop-filter").length < 1) {
      $(".filter-content").slideUp(300);
    }
  }
});

$("document").ready(function () {
  // Product recommendations slider
  // var productRecommendationSlider = $(
  //   ".product-recommendations .grid--view-items"
  // );
  // if ($(window).width() < 750) {
  //   productRecommendationSlider.slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: true,
  //     adaptiveHeight: true,
  //     infinite: false,
  //   });
  // }

  // Accordion Script
  $(".accordion-header.active").next().stop().slideDown();
  $(".accordion-header").on("click", function () {
    const next_sibling = $(this).next();
    $(".accordion-content").not(next_sibling).stop().slideUp();
    $(".accordion-header").not(this).removeClass("active");
    $(this).toggleClass("active").next().stop().slideToggle();
  });

  // PDP Buy now button starts here
  var InventoryPolicy;
  function ProductFormData($this) {
    var formData = $this.closest("form").serializeArray();
    var variantId = $('[name="id"]').find(":selected").val();
    var proQuantity = $('.product__quantity [name="quantity"]').val();
    // var isPersonalizeProduct = $('.name_engraving').length;
    //clear.js, //add.js
    if (InventoryPolicy == "continue" && inventory_level < 1) {
      formData = {
        items: [
          {
            id: variantId,
            quantity: proQuantity,
            properties: {
              "Delivery Time": "2 weeks",
            },
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: variantId,
            quantity: proQuantity,
          },
        ],
      };
    }
    return formData;
  }

  $(".productFormBuyNow[data-buynow]").on("click", function (e) {
    e.preventDefault();
    // var variantId = $('[name="id"]').find(":selected").val();
    var $this = $(this);
    console.log("buynow", ProductFormData($this));
    function ajaxAdd(data) {
      $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: data,
        beforeSend: function () {
          $this.find(".before-touch").addClass("hide");
          $this.find(".after-touch").css("display", "block");
        },
        success: function () {
          checkoutURL = window.location = "/checkout";
        },
        error: function (error) {
          console.log("error", error.responseJSON.description);
          $this
            .siblings(".error_message")
            .removeClass("hide")
            .text(error.responseJSON.description);
          $this.find("span").removeClass("hide");
          $this.find("[data-loader]").addClass("hide");
        },
      });
    }
    if (ProductFormData($this)) {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          ajaxAdd(ProductFormData($this));
        },
        error: function (error) {
          console.log("error", error.responseJSON.description);
        },
      });
    }
  });
  // PDP Buy now button ends here
 
  // PDP media slider - mobile
  if ($(window).width() < 750) {
    // var $mediaSlider = $(".product-single .product-single__media-group-inner");

    var $mediaSlider = new Swiper('.product-single__media-group-inner', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      allowTouchMove: true,
      autoHeight: false,
    });

    // setTimeout(function () {
    //   var $select = $('[id^="ProductSelect-"]');
    //   var variantId = theme.getVariantIdFromUrlOrDefault($select);
    //   var variantHandle = $select
    //     .find('option[value="' + variantId + '"]')
    //     .data("variantHandle");
    //   var productVariantSize = parseInt(theme.productVariantSize, 10) || 0;

    //   if (typeof theme.refreshPdpMobileMediaSlider === "function") {
    //     theme.refreshPdpMobileMediaSlider(
    //       variantHandle,
    //       productVariantSize < 2
    //     );
    //   }
    // }, 150);
  }
});
if ($(window).width() > 749) {
  $(document).ready(function () {
    $(".collection-slider-wrapper").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      spacebeetween: 20,
    });
  });
}
// Craftman slider
// $(document).ready(function () {
//   $(".collection-slide-parent").slick({
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     slidesToShow: 1,
//     adaptiveHeight: true,
//     arrows: false,
//   });
// });
  
// Website popup scripts starts here
$(document).on("click", ".diamond-color-popup-btn", function () {
  $("body").addClass("show-website-popup");
  $("#diamond-color-popup").addClass("show-popup-content");
});
$(document).on("click", ".diamond-clarity-popup-btn", function () {
  $("body").addClass("show-website-popup");
  $("#diamond-clarity-popup").addClass("show-popup-content");
});
$(document).on("click", ".metal-guide-popup-btn", function () {
  $("body").addClass("show-website-popup");
  $("#metal-guide-popup").addClass("show-popup-content");
});
$(document).on("click",".close-popup,.popup-overlay", function () {
  theme.close_popup();
});
// Website popup scripts ends here